import { Box, Grid } from "@mui/material";
import { ISingleCourseDetails } from "src/Types/module/courses/courseList";
import { getStatusLabel } from "src/Utils/Combined";
import CommonDetailItem from "src/components/CommonDetailItem/CommonDetailItem";

interface IProps {
  course: ISingleCourseDetails;
}
function SingleCourseDetails({ course }: IProps) {
  const {
    atab_training_course_id,
    atab_training_course_name,
    atab_training_course_duration,
    atab_training_course_class_duration,
    atab_training_course_class_time,
    atab_training_course_class_days,
    atab_training_course_amount,
    atab_training_course_discount_amount,
    atab_training_course_remark,
    atab_training_course_status,
  } = course;

  const labelWidth = { xs: "120px", sm: "140px", md: "160px" };

  return (
    <div>
      <Box sx={{ mt: 3 }}>
        <Grid container spacing={{ xs: 2, md: 3 }}>

          <CommonDetailItem
            label='Name'
            value={atab_training_course_name}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Course Status'
            value={getStatusLabel(atab_training_course_status)}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Course Duration'
            value={atab_training_course_duration}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Class Duration'
            value={atab_training_course_class_duration}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Class Time'
            value={atab_training_course_class_time}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Class Days'
            value={atab_training_course_class_days}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Course Amount'
            value={atab_training_course_amount}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Discount Amount (Applicable for ATAB Members)'
            value={atab_training_course_discount_amount}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
          <CommonDetailItem
            label='Course Remark'
            value={atab_training_course_remark}
            labelWidth={labelWidth}
            xs={12}
            md={6}
          />
        </Grid>
      </Box>
    </div>
  );
}

export default SingleCourseDetails;
